import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ShieldCheckIcon, MailIcon, RefreshCwIcon } from 'lucide-react';
export function RiskReversalSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark-section py-20 md:py-28" data-id="element-225">
      <div className="max-w-3xl mx-auto px-6" data-id="element-226">
        <motion.div className="text-center mb-10" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6
      }} data-id="element-227">
          <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center bg-orange-accent/10 border-2 border-orange-accent rounded-full" data-id="element-228">
            <ShieldCheckIcon className="w-10 h-10 text-orange-accent" data-id="element-229" />
          </div>
          <h2 className="font-bebas text-4xl md:text-5xl lg:text-6xl text-white tracking-wide mb-4" data-id="element-230">
            THE <span className="text-orange-accent" data-id="element-231">"IRON-CLAD"</span>{' '}
            GUARANTEE
          </h2>
        </motion.div>

        <motion.div className="bg-dark-card border border-orange-accent/30 p-8 md:p-10" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-232">
          <p className="font-inter text-lg text-white leading-relaxed mb-6" data-id="element-233">
            I'm so confident this guide will transform how you think about home
            security that I'm putting all the risk on my shoulders.
          </p>

          <p className="font-inter text-concrete leading-relaxed mb-6" data-id="element-234">
            Download the complete Concrete Bunker Blueprint. Review every page.
            Watch every diagram. If at any point in the next{' '}
            <span className="text-orange-accent font-bold" data-id="element-235">60 days</span> you
            decide this isn't right for you — for ANY reason — just send one
            email and I'll refund every penny.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 my-8" data-id="element-236">
            <div className="flex items-center gap-3" data-id="element-237">
              <RefreshCwIcon className="w-6 h-6 text-orange-accent flex-shrink-0" data-id="element-238" />
              <span className="font-inter text-white text-sm" data-id="element-239">
                60-Day Full Refund
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-240">
              <MailIcon className="w-6 h-6 text-orange-accent flex-shrink-0" data-id="element-241" />
              <span className="font-inter text-white text-sm" data-id="element-242">
                One Email, Done
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-243">
              <ShieldCheckIcon className="w-6 h-6 text-orange-accent flex-shrink-0" data-id="element-244" />
              <span className="font-inter text-white text-sm" data-id="element-245">
                No Questions Asked
              </span>
            </div>
          </div>

          <p className="font-inter text-concrete leading-relaxed mb-6" data-id="element-246">
            You don't even need to give a reason. Maybe you changed your mind.
            Maybe you decided to move. Maybe you just didn't like my writing
            style. <span className="text-white" data-id="element-247">Doesn't matter.</span>
          </p>

          <p className="font-inter text-lg text-white leading-relaxed" data-id="element-248">
            The only way you lose is if you do nothing — and leave your
            collection exposed for another day.
          </p>
        </motion.div>

        <motion.p className="text-center mt-8 font-inter text-sm text-concrete/60" initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {
        opacity: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-249">
          Refund requests processed within 24 hours. No hoops. No hassle.
        </motion.p>
      </div>
    </section>;
}